<div class="mat-modal-dialog on-call-booking-action-modal">
    <h2 mat-dialog-title class="dialog-title-bar">
        <div class="d-flex align-items-center">
            <span class="material-icons-outlined title-icon me-2">info</span>
            <span class="title-text">{{ dialogTitle }}</span>
        </div>
        <mat-icon class="close-icon" (click)="onCancel()">close</mat-icon>
    </h2>

    <mat-dialog-content>
        <div class="booking-summary-card mb-4">
            <div class="row">
                <div class="col-sm-6 col-md-6 mb-2">
                    <label class="font-size-font summary-label">Passenger Name</label>
                    <div class="summary-value">{{ employeeName || '-' }}</div>
                </div>
                <div class="col-sm-6 col-md-6 mb-2">
                    <label class="font-size-font summary-label">Travel Date</label>
                    <div class="summary-value">{{ bookingData.travelDate }}</div>
                </div>
                <div class="col-sm-6 col-md-6 mb-2">
                    <label class="font-size-font summary-label">Reporting Time</label>
                    <div class="summary-value">{{ bookingData.reportingTime }}</div>
                </div>
                <div class="col-sm-6 col-md-6 mb-2" *ngIf="driverMobileNumber">
                    <label class="font-size-font summary-label">Driver Mobile</label>
                    <div class="summary-value">{{ driverMobileNumber }}</div>
                </div>
            </div>
        </div>

        <div class="section-heading mb-3">Allocation Details</div>
        <div class="row">
            <div class="col-sm-6 col-md-6 mb-3">
                <label class="font-size-font">Vendor Master<sup class="mandatory">*</sup></label>
                <select class="form-select" *ngIf="isAdminUser; else fixedVendor" [(ngModel)]="vendorId"
                    (change)="onVendorChange()">
                    <option value="" disabled>Choose Vendor</option>
                    <option *ngFor="let vendor of vendorList" [value]="vendor.id">{{ vendor.name }}</option>
                </select>
                <ng-template #fixedVendor>
                    <input class="form-control" type="text" [value]="vendorName" readonly>
                </ng-template>
            </div>

            <div class="col-sm-6 col-md-6 mb-3">
                <label class="font-size-font">Vehicle Type<sup class="mandatory">*</sup></label>
                <input class="form-select" type="text" placeholder="Search vehicle type"
                    [ngModel]="vehicleTypeSearch" (ngModelChange)="onVehicleTypeSearch($event)"
                    (focus)="showAllVehicleTypes()" [matAutocomplete]="vehicleTypeAuto" autocomplete="off">
                <mat-autocomplete #vehicleTypeAuto="matAutocomplete" panelClass="allocation-option-panel"
                    [displayWith]="showVehicleType" (optionSelected)="selectVehicleType($event.option.value)">
                    <mat-option *ngFor="let vehicleType of filteredVehicleTypes" [value]="vehicleType"
                        style="font-size: 14px !important; font-weight: 400 !important;">
                        {{ vehicleType.vehicleType }}
                    </mat-option>
                </mat-autocomplete>
                <div class="error-msg" *ngIf="vehicleTypeNoMatch">No data found</div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 mb-3">
                <label class="font-size-font">Vehicle<sup class="mandatory">*</sup></label>
                <input class="form-select" type="text" placeholder="Search vehicle no."
                    [ngModel]="vehicleSearch" (ngModelChange)="onVehicleSearch($event)" (focus)="showAllVehicles()"
                    [matAutocomplete]="vehicleAuto" autocomplete="off">
                <mat-autocomplete #vehicleAuto="matAutocomplete" panelClass="allocation-option-panel"
                    [displayWith]="showVehicle" (optionSelected)="selectVehicle($event.option.value)">
                    <mat-option *ngFor="let vehicle of filteredVehicles" [value]="vehicle"
                        style="font-size: 14px !important; font-weight: 400 !important;">
                        {{ vehicle.registrationNo }}
                    </mat-option>
                </mat-autocomplete>
                <div class="error-msg" *ngIf="vehicleNoMatch">No data found</div>
            </div>
            <div class="col-sm-6 col-md-6 mb-3">
                <label class="font-size-font">Driver<sup class="mandatory">*</sup></label>
                <input class="form-select" type="text" placeholder="Search driver" [ngModel]="driverSearch"
                    (ngModelChange)="onDriverSearch($event)" (focus)="showAllDrivers()" [matAutocomplete]="driverAuto"
                    autocomplete="off">
                <mat-autocomplete #driverAuto="matAutocomplete" panelClass="allocation-option-panel"
                    [displayWith]="showDriver" (optionSelected)="selectDriver($event.option.value)">
                    <mat-option *ngFor="let driver of filteredDrivers" [value]="driver"
                        style="font-size: 14px !important; font-weight: 400 !important;">
                        {{ driver.name }}
                    </mat-option>
                </mat-autocomplete>
                <div class="error-msg" *ngIf="driverNoMatch">No data found</div>
            </div>
        </div>
    </mat-dialog-content>

    <div mat-dialog-actions align="end">
        <button class="btn footerBtn secondary-btn-solid me-3" (click)="onCancel()">Cancel</button>
        <button class="btn footerBtn red-btn-solid" (click)="onApprove()">{{ confirmButtonLabel }}</button>
    </div>
</div>